import UserLink from 'src/modules/shared/links/userLink';
import { Element, Section } from 'src/constants/footfall';
import Badge from 'src/components/badge';
import { SupportingMember } from 'src/constants/types';
import { SupportingMembers, SupportingMemberEl, SupportingMemberAvatar, SupportingMemberUser,
  SupportingMemberLink } from 'src/modules/community/communityAbout/components/sharedStyles';
import { Size } from 'src/components/avatar';

type Props = {
  supportingMembers: SupportingMember[];
}

export default function SupportingMembersList({ supportingMembers }: Props): JSX.Element {
  return (
    <SupportingMembers>
      {supportingMembers.map(user => {
        const { username, userImageHash, role } = user;
        return (
          <SupportingMemberEl key={username}>
            <SupportingMemberAvatar>
              <UserLink
                avatarSize={Size.Small}
                signupContext={{
                  element: Element.AVATAR,
                  section: Section.CommunityAbout,
                }}
                user={{
                  username,
                  userImageHash,
                }}
              />
            </SupportingMemberAvatar>
            <SupportingMemberUser>
              <SupportingMemberLink
                signupContext={{
                  element: Element.USER_LINK,
                  section: Section.CommunityAbout,
                }}
                user={{ username }}
              />
              <Badge>{role}</Badge>
            </SupportingMemberUser>
          </SupportingMemberEl>
        );
      })}
    </SupportingMembers>
  );
}
